import { render, staticRenderFns } from "./ReservationTop.vue?vue&type=template&id=51b5144a&scoped=true"
import script from "./ReservationTop.vue?vue&type=script&lang=js"
export * from "./ReservationTop.vue?vue&type=script&lang=js"
import style0 from "./ReservationTop.vue?vue&type=style&index=0&id=51b5144a&prod&scoped=true&lang=scss"
import style1 from "./ReservationTop.vue?vue&type=style&index=1&id=51b5144a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b5144a",
  null
  
)

export default component.exports